module.exports = __webpack_public_path__ + "static/media/39_tn.03e0b8dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/39_tn.jpg
// module id = 348
// module chunks = 0